import { useMemo } from 'react'
import { useTranslation } from './use-i18n'
import { useNavSpaces } from './useNavSpaces'

export type NavLinkItem = {
  to: string
  label: string
  isActive: (pathname: string) => boolean
}

export function useAuthNavLinks(pathname: string) {
  const { t } = useTranslation()
  const { showRestaurantTab, showHowIEatTab, howIEatSpace } = useNavSpaces()

  const links = useMemo(() => {
    const items: NavLinkItem[] = []

    if (showRestaurantTab) {
      items.push({
        to: '/restaurants',
        label: t('nav.restaurant'),
        isActive: (p) => p === '/restaurants' || p.startsWith('/restaurant/'),
      })
    }

    if (showHowIEatTab && howIEatSpace) {
      const spaceId = howIEatSpace._id || howIEatSpace.id
      items.push({
        to: `/how-i-eat/${spaceId}`,
        label: t('nav.howIEat'),
        isActive: (p) => p.startsWith('/how-i-eat/'),
      })
    }

    items.push(
      {
        to: '/dashboard',
        label: t('nav.home'),
        isActive: (p) => p === '/dashboard',
      },
      {
        to: '/around',
        label: t('nav.around'),
        isActive: (p) => p === '/around',
      },
      {
        to: '/account',
        label: t('nav.account'),
        isActive: (p) => p === '/account' || p === '/staff-invitations',
      },
    )

    return items.map((item) => ({ ...item, active: item.isActive(pathname) }))
  }, [showRestaurantTab, showHowIEatTab, howIEatSpace, pathname, t])

  return links
}
